"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrintReportElements = PrintReportElements;
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _ButtonElement = _interopRequireDefault(require("../button/ButtonElement"));
var _FormInput = _interopRequireDefault(require("../Form/FormInput"));
require("./printReport.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// @flow

function PrintReportElements(_ref) {
  var id = _ref.id,
    show = _ref.show,
    setIsForPrintFundsAsSinglePDF = _ref.setIsForPrintFundsAsSinglePDF,
    isForPrintFundsAsSinglePDF = _ref.isForPrintFundsAsSinglePDF,
    setFundId = _ref.setFundId,
    toggle1 = _ref.toggle1,
    downloadFyReportPrintBridge = _ref.downloadFyReportPrintBridge,
    closeModal = _ref.closeModal,
    fundList = _ref.fundList,
    setisForImpactPDFDocument = _ref.setisForImpactPDFDocument,
    setisForNarrativePDFDocument = _ref.setisForNarrativePDFDocument,
    isForNarrativePDFDocument = _ref.isForNarrativePDFDocument,
    isForMostRecentUpdates = _ref.isForMostRecentUpdates,
    setisForMostRecentUpdates = _ref.setisForMostRecentUpdates,
    setcurrentAllUpdates = _ref.setcurrentAllUpdates,
    currentAllUpdates = _ref.currentAllUpdates,
    marginToLeft = _ref.marginToLeft;
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal, {
    id: id,
    show: show,
    centered: true,
    className: "print-report-modal"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Header, {
    className: "bg-primary text-white modal-variant"
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "modal-title"
  }, "Print Report Elements")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Body, {
    className: ""
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-padding"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Card, {
    className: "mb-0"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Card.Body, null, /*#__PURE__*/_react.default.createElement("div", {
    class: "group"
  }, /*#__PURE__*/_react.default.createElement("div", {
    class: "section"
  }, /*#__PURE__*/_react.default.createElement("div", {
    class: "text-wrapper"
  }, "Tab Selection:"), /*#__PURE__*/_react.default.createElement("div", {
    class: "row1"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: currentAllUpdates === 1 ? "frame current-update active" : "frame current-update",
    for: "currentAllUpdates1",
    onClick: function onClick() {
      return setcurrentAllUpdates(1);
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    class: "div"
  }, /*#__PURE__*/_react.default.createElement("div", {
    class: "div-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_FormInput.default, {
    type: "radio",
    id: "currentAllUpdates1",
    name: "currentAllUpdates",
    className: "mt-0 icon-radio text-wrapper-2",
    value: 1,
    label: "Current tab only",
    checked: currentAllUpdates === 1 ? true : false,
    icon: currentAllUpdates === 1 ? /*#__PURE__*/_react.default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "M13,9V3.5L18.5,9M6,2C4.89,2 4,2.89 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2H6Z"
    })) : /*#__PURE__*/_react.default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"
    }))
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: currentAllUpdates === 2 ? "frame all-update active" : "frame all-update",
    for: "currentAllUpdates2",
    onClick: function onClick() {
      return setcurrentAllUpdates(2);
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    class: "div"
  }, /*#__PURE__*/_react.default.createElement("div", {
    class: "div-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_FormInput.default, {
    type: "radio",
    id: "currentAllUpdates2",
    name: "currentAllUpdates",
    className: "mt-0 icon-radio text-wrapper-2",
    value: 2,
    label: "All tabs",
    checked: currentAllUpdates === 2 ? true : false,
    icon: currentAllUpdates === 2 ? /*#__PURE__*/_react.default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "M15,7H20.5L15,1.5V7M8,0H16L22,6V18A2,2 0 0,1 20,20H8C6.89,20 6,19.1 6,18V2A2,2 0 0,1 8,0M4,4V22H20V24H4A2,2 0 0,1 2,22V4H4Z"
    })) : /*#__PURE__*/_react.default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "M16 0H8C6.9 0 6 .9 6 2V18C6 19.1 6.9 20 8 20H20C21.1 20 22 19.1 22 18V6L16 0M20 18H8V2H15V7H20V18M4 4V22H20V24H4C2.9 24 2 23.1 2 22V4H4Z"
    }))
  })))))), /*#__PURE__*/_react.default.createElement("div", {
    class: "section"
  }, /*#__PURE__*/_react.default.createElement("div", {
    class: "text-wrapper"
  }, "Print Options:"), /*#__PURE__*/_react.default.createElement("div", {
    class: "row-2"
  }, /*#__PURE__*/_react.default.createElement("div", {
    class: "frame-2 more"
  }, /*#__PURE__*/_react.default.createElement("div", {
    class: "frame-3"
  }, /*#__PURE__*/_react.default.createElement(_FormInput.default, {
    type: "radio",
    id: "printAllSinglePdf",
    name: "printType",
    className: "mt-0 text-wrapper-3",
    value: 1,
    label: "Print all funds as a single PDF",
    onChange: setIsForPrintFundsAsSinglePDF,
    checked: isForPrintFundsAsSinglePDF === 1 ? true : false
  })), /*#__PURE__*/_react.default.createElement("div", {
    class: "frame-3"
  }, /*#__PURE__*/_react.default.createElement(_FormInput.default, {
    type: "radio",
    id: "printAllSeparatePdf",
    name: "printType",
    value: 2,
    label: "Print all funds as separate PDFs",
    className: "mt-1 text-wrapper-3",
    onChange: setIsForPrintFundsAsSinglePDF,
    checked: isForPrintFundsAsSinglePDF === 2 ? true : false
  })), /*#__PURE__*/_react.default.createElement("div", {
    class: "frame-3"
  }, /*#__PURE__*/_react.default.createElement("div", {
    class: "frame-4"
  }, /*#__PURE__*/_react.default.createElement(_FormInput.default, {
    type: "radio",
    id: "printSingleFund",
    name: "printType",
    value: 3,
    label: "Print a single fund...",
    className: "mt-1 text-wrapper-2",
    onChange: setIsForPrintFundsAsSinglePDF,
    checked: isForPrintFundsAsSinglePDF === 3 ? true : false
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "select-fund-drop-down"
  }, /*#__PURE__*/_react.default.createElement(_FormInput.default, {
    type: "select",
    className: "custom-select mt-1 ms-3 text-wrapper-4",
    disabled: isForPrintFundsAsSinglePDF === 3 ? false : true,
    onChange: function onChange(e) {
      return setFundId(e.target.value);
    }
    // label="Select Fund"
  }, /*#__PURE__*/_react.default.createElement("option", null, "Select Fund"), fundList === null || fundList === void 0 ? void 0 : fundList.map(function (y) {
    return /*#__PURE__*/_react.default.createElement("option", {
      key: y.id,
      value: y.pkFundId
    }, y.colFundName);
  })))))), /*#__PURE__*/_react.default.createElement("div", {
    class: "frame-2"
  }, /*#__PURE__*/_react.default.createElement("div", {
    class: "frame-3"
  }, /*#__PURE__*/_react.default.createElement(_FormInput.default, {
    type: "checkbox",
    id: "printSupplementDocument",
    className: "mt-0 text-wrapper-3",
    label: "Include supplemental documents",
    onChange: setisForImpactPDFDocument
  })), /*#__PURE__*/_react.default.createElement("div", {
    class: "frame-3"
  }, /*#__PURE__*/_react.default.createElement(_FormInput.default, {
    type: "checkbox",
    id: "printNarrative",
    className: "mt-1 text-wrapper-2",
    label: "Include narrative report content",
    onChange: setisForNarrativePDFDocument
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "frame-3 d-none"
  }, /*#__PURE__*/_react.default.createElement(_FormInput.default, {
    type: "radio",
    id: "mostRecentUpdate",
    name: "reportUpdates",
    value: 1,
    label: "Most Recent Update",
    className: "mt-1 ms-2",
    onChange: setisForMostRecentUpdates,
    checked: isForMostRecentUpdates === 1 ? true : false,
    disabled: !isForNarrativePDFDocument
  }), /*#__PURE__*/_react.default.createElement(_FormInput.default, {
    type: "radio",
    id: "allUpdates",
    value: 2,
    name: "reportUpdates",
    label: "All Updates",
    className: "ms-2 mt-1",
    onChange: setisForMostRecentUpdates,
    checked: isForMostRecentUpdates === 2 ? true : false,
    disabled: !isForNarrativePDFDocument
  })))))))))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Footer, {
    className: "d-flex justify-content-center"
  }, /*#__PURE__*/_react.default.createElement(_ButtonElement.default, {
    name: "Print",
    variant: "primary",
    type: "button",
    onClick: downloadFyReportPrintBridge,
    disabled: currentAllUpdates === 1 ? false : toggle1
  }), /*#__PURE__*/_react.default.createElement(_ButtonElement.default, {
    name: "Cancel",
    variant: "light",
    type: "button",
    onClick: closeModal
  })));
}
var _default = PrintReportElements;
exports.default = _default;